import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const LoginForm = ({ onSubmit, isLoading }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      return 'Email address is required';
    }
    if (!emailRegex?.test(email)) {
      return 'Please enter a valid email address';
    }
    return '';
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    const emailError = validateEmail(email);
    if (emailError) {
      setErrors({ email: emailError });
      return;
    }

    setErrors({});
    onSubmit(email);
  };

  const handleEmailChange = (e) => {
    setEmail(e?.target?.value);
    if (errors?.email) {
      setErrors({});
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-2">
        <Input
          type="email"
          label="Corporate Email Address"
          placeholder="admin@rpmdiesel.com"
          value={email}
          onChange={handleEmailChange}
          error={errors?.email}
          required
          disabled={isLoading}
          description="Enter your RPM Diesel corporate email to receive a secure magic link"
        />
      </div>
      <Button
        type="submit"
        variant="default"
        fullWidth
        loading={isLoading}
        iconName="Mail"
        iconPosition="left"
      >
        {isLoading ? 'Sending Magic Link...' : 'Send Magic Link'}
      </Button>
      <div className="flex items-center justify-center space-x-2 text-sm text-muted-foreground">
        <Icon name="Info" size={16} strokeWidth={2} />
        <span>Password-less authentication for enhanced security</span>
      </div>
      <div className="pt-4 border-t border-border">
        <Button
          type="button"
          variant="ghost"
          fullWidth
          iconName="ArrowLeft"
          iconPosition="left"
          onClick={() => navigate('/driver-lookup-portal')}
        >
          Back to Driver Lookup
        </Button>
      </div>
    </form>
  );
};

export default LoginForm;